(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artists"] && !Shopify.designMode) return;
  try {
    

function isTouchDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia("(pointer: coarse)").matches
  );
}

gsap.registerPlugin(ScrollTrigger);

if (isTouchDevice()) {

  document.addEventListener("DOMContentLoaded", function () {
    const anchors = document.querySelectorAll(".artists-list a");
    const imgElement = document.querySelector(".artists-list--img img");
    const imgAnchor = document.querySelector(".artists-list--img a");
  
    anchors.forEach(anchor => {
      const imgSrc = anchor.getAttribute("data-img");
      if (imgSrc) {
        const img = new Image();
        img.src = imgSrc;
      }
    });
  
    function updateActive(anchor) {
      // Remove .active from all anchors
      anchors.forEach(a => a.classList.remove("active"));
  
      // Add .active to the given anchor
      anchor.classList.add("active");
  
      // Update image
      const imgSrc = anchor.getAttribute("data-img");
      imgElement.setAttribute("src", imgSrc);
      imgElement.classList.add("active");
      const artistLink = anchor.getAttribute("data-href");
      imgAnchor.setAttribute("href", artistLink);
    }
  
    // HOVER behavior
    anchors.forEach(anchor => {
      anchor.addEventListener("mouseenter", function () {
        updateActive(this);
      });
    });

    anchors[0].classList.add("active");
    let imgSrcFirst = anchors[0].getAttribute("data-img");
    let artistLinkFirst = anchors[0].getAttribute("data-href");
    imgElement.setAttribute("src", imgSrcFirst);
    imgElement.classList.add("active");
    imgAnchor.setAttribute("href", artistLinkFirst);
  
    // SCROLLTRIGGER behavior
    anchors.forEach(anchor => {
      ScrollTrigger.create({
        trigger: anchor,
        start: "top 50%",
        end: "bottom bottom",
        onEnter: () => updateActive(anchor),
        onEnterBack: () => updateActive(anchor),
        markers: false // turn on if you want to debug: `true`
      });
    });
  
    setTimeout(function(){
      ScrollTrigger.refresh();
    }, 700);
      
  });
  
  window.addEventListener("load", () => {
    ScrollTrigger.refresh();
  });

  gsap.to(".artists-list--img", {
    top: "50%",
    scrollTrigger: {
      trigger: document.body, // use scroll position of entire page
      start: "top top",  // animation starts when scrollY is 300px
      end: "top+=600 top",    // ends at 600px scroll
      scrub: true,            // makes it scroll-linked
    }
  });

  gsap.to(".artists-list--img", {
    yPercent: -50,
    scrollTrigger: {
      trigger: document.body, // use scroll position of entire page
      start: "top+=300 top",  // animation starts when scrollY is 300px
      end: "top+=600 top",    // ends at 600px scroll
      scrub: true,            // makes it scroll-linked
    }
  });
  
} else {

  document.addEventListener("DOMContentLoaded", function () {
    const anchors = document.querySelectorAll(".artists-list a");
    const figure = document.querySelector(".artists-list--img");
    const link = figure.querySelector("a");
    const img = link.querySelector("img");
  
    anchors.forEach(anchor => {
      anchor.addEventListener("mouseenter", function () {
        // Remove .active from all anchors
        anchors.forEach(a => a.classList.remove("active"));
        this.classList.add("active");

        let currentLink = this.getAttribute("href");
  
        // Swap image
        const imgSrc = this.getAttribute("data-img");
        img.setAttribute("src", imgSrc);
        img.classList.add("active");
        link.setAttribute("href", currentLink);

        /*
        // Position the image near the hovered anchor
        const anchorRect = this.getBoundingClientRect();
        const figureRect = figure.getBoundingClientRect();
  
        // Calculate vertical position relative to the figure container
        let y = anchorRect.top - figureRect.top;
  
        // Center the image on the link
        y -= img.offsetHeight / 2;
        const minY = 0;
        const maxY = figure.offsetHeight - img.offsetHeight;
        y = Math.max(minY, Math.min(y, maxY));
  
        // Apply absolute positioning
        link.style.position = 'absolute';
        link.style.top = `${y}px`;
        */
        
      });
    });
  });
  
}
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel-danny"] && !Shopify.designMode) return;
  try {
    

// First, detect if we're in Safari on OSX.
// Detect if Safari on OSX for fallback delay adjustment.
const userAgent = navigator.userAgent;
const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
const isSafariOSX = isSafari && isMac;

// Global debug settings for grid and animation parameters
const debugSettings = {
  desiredMinSpacing: 136,    // Minimum desired spacing (px)
  scaleFactor: 29,           // The multiplier applied by the CSS animation
  animationSpeed: 0.5,       // Animation duration (in seconds) for each circle
  delayMultiplier: 29,       // Delay per (row+col) unit (in ms)
  cellRatio: 0.9             // Fraction of each cell that the final circle should fill
};

// Set custom viewport height variable
function setVh() {
  document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
}
window.addEventListener('load', setVh);
window.addEventListener('resize', setVh);
window.addEventListener('orientationchange', setVh);

// Variables & initial setup
let isTransitioning = false;
let currentSlideIndex = 0;
const slides = document.querySelectorAll('.carousel .slide');
const totalSlides = slides.length;
let slideInterval = setInterval(nextSlide, 5000);

// Ensure only the active slide is visible initially
slides.forEach((slide, i) => {
  if (i === 0) {
    slide.classList.add('active');
    slide.style.display = 'block';
  } else {
    slide.classList.remove('active');
    slide.style.display = 'none';
  }
});

function updateIndicators() {
  document.querySelectorAll('.indicator-hit').forEach((el, i) => {
    const indicator = el.querySelector('.indicator');
    if (i === currentSlideIndex) {
      indicator.classList.add('active');
    } else {
      indicator.classList.remove('active');
    }
  });
}

// Transition using an inline SVG mask with sequential animation.
function transitionToSlide(newIndex) {
  if (isTransitioning) return;
  isTransitioning = true;

  const currentSlide = slides[currentSlideIndex];
  const nextSlide = slides[newIndex];

  // Make sure next slide is visible beneath the current slide
  nextSlide.style.display = 'block';
  nextSlide.style.zIndex = '1';
  currentSlide.style.zIndex = '2';

  const containerWidth = window.innerWidth;
  const containerHeight = document.querySelector('.carousel-container').clientHeight;
  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, "svg");
  svg.setAttribute("width", containerWidth);
  svg.setAttribute("height", containerHeight);
  svg.style.position = "absolute";
  svg.style.top = "0";
  svg.style.left = "0";
  svg.style.pointerEvents = "none";

  // Wrap the mask in <defs> for Safari
  const defs = document.createElementNS(svgNS, "defs");
  const mask = document.createElementNS(svgNS, "mask");
  mask.setAttribute("id", "transitionMask");
  mask.setAttribute("maskUnits", "userSpaceOnUse");
  defs.appendChild(mask);
  svg.appendChild(defs);

  // A white rect to make the whole slide visible by default
  const rect = document.createElementNS(svgNS, "rect");
  rect.setAttribute("x", 0);
  rect.setAttribute("y", 0);
  rect.setAttribute("width", "100%");
  rect.setAttribute("height", "100%");
  rect.setAttribute("fill", "white");
  mask.appendChild(rect);

  // Calculate grid dimensions based on desiredMinSpacing.
  const desiredMinSpacing = debugSettings.desiredMinSpacing;
  const cols = Math.max(1, Math.floor(containerWidth / desiredMinSpacing));
  const rows = Math.max(1, Math.floor(containerHeight / desiredMinSpacing));
  const xSpacing = containerWidth / cols;
  const ySpacing = containerHeight / rows;
  const effectiveSpacing = Math.min(xSpacing, ySpacing);
  const finalCircleDiameter = effectiveSpacing * debugSettings.cellRatio;
  const baseCircleDiameter = finalCircleDiameter / debugSettings.scaleFactor;
  const baseRadius = baseCircleDiameter / 2;

  // Create a grid of circles that will animate sequentially.
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const cx = col * xSpacing + xSpacing / 2;
      const cy = row * ySpacing + ySpacing / 2;
      const circle = document.createElementNS(svgNS, "circle");
      circle.setAttribute("cx", cx);
      circle.setAttribute("cy", cy);
      circle.setAttribute("r", baseRadius);
      circle.setAttribute("fill", "black");
      circle.style.transform = "scale(0)";
      circle.style.transformOrigin = "center";
      circle.style.transformBox = "fill-box";
      circle.classList.add("mask-circle");
      const delay = (row + col) * debugSettings.delayMultiplier;
      circle.style.animation = `maskExpand ${debugSettings.animationSpeed}s forwards`;
      circle.style.animationDelay = delay + "ms";
      circle.style.webkitAnimation = `maskExpand ${debugSettings.animationSpeed}s forwards`;
      circle.style.webkitAnimationDelay = delay + "ms";
      mask.appendChild(circle);
    }
  }

  svg.appendChild(mask);
  currentSlide.appendChild(svg);

  // Force a reflow so Safari picks up the mask changes.
  void currentSlide.offsetHeight;

  // Apply the mask to the current slide with extra webkit properties.
  currentSlide.style.mask = "url(#transitionMask) no-repeat center / cover";
  currentSlide.style.webkitMask = "url(#transitionMask) no-repeat center / cover";
  currentSlide.style.maskType = "luminance";
  currentSlide.style.webkitMaskType = "luminance";

  // Compute total delay normally…
  let totalDelay = ((rows - 1 + cols - 1) * debugSettings.delayMultiplier) + (debugSettings.animationSpeed * 1000);
  // ...but if we're on Safari OSX, override to have no delay before fade-out.
  if (isSafariOSX) {
    totalDelay = 0;
  }

  setTimeout(() => {
    currentSlide.style.transition = "opacity 0.2s ease";
    currentSlide.style.opacity = "0";
    setTimeout(() => {
      currentSlide.style.transition = "";
      currentSlide.style.opacity = "1"; // reset opacity for future transitions
      currentSlide.style.mask = "";
      currentSlide.style.webkitMask = "";
      currentSlide.removeChild(svg);
      currentSlide.classList.remove("active");
      currentSlide.style.display = "none";
      nextSlide.classList.add("active");
      nextSlide.style.zIndex = "2";
      currentSlideIndex = newIndex;
      updateIndicators();
      isTransitioning = false;
    }, 200);
  }, totalDelay);
}

function nextSlide() {
  const newIndex = (currentSlideIndex + 1) % totalSlides;
  transitionToSlide(newIndex);
  resetTimer();
}

function previousSlide() {
  const newIndex = (currentSlideIndex - 1 + totalSlides) % totalSlides;
  transitionToSlide(newIndex);
  resetTimer();
}

function resetTimer() {
  clearInterval(slideInterval);
  slideInterval = setInterval(nextSlide, 5000);
}

// Attach arrow click events.
document.querySelector('.arrow-area.left .arrow-button').addEventListener('click', previousSlide);
document.querySelector('.arrow-area.right .arrow-button').addEventListener('click', nextSlide);

// Attach click events to indicators.
document.querySelectorAll('.indicator-hit').forEach(el => {
  el.addEventListener('click', () => {
    const targetIndex = parseInt(el.getAttribute('data-slide'));
    if (targetIndex !== currentSlideIndex) {
      transitionToSlide(targetIndex);
      resetTimer();
    }
  });
});

// Remove the mask on resize (cleanup)
window.addEventListener('resize', () => {
  slides.forEach(slide => {
    slide.style.mask = "";
    slide.style.webkitMask = "";
    while (slide.lastChild && slide.lastChild.nodeName === "svg") {
      slide.removeChild(slide.lastChild);
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const links = document.querySelectorAll('[data-dropdown="sort"] a');
    const params = new URLSearchParams(window.location.search);
    const currentSort = params.get('sort_by');
  
    links.forEach(link => {
      const linkSort = new URL(link.href, window.location.origin).searchParams.get('sort_by');
      if (linkSort === currentSort) {
        link.classList.add('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    // Select the element where the success message will appear
    const successResponse = document.querySelector("#mce-success-response");
    const form = document.querySelector("#mc-embedded-subscribe-form");
    const formText = document.querySelector(".signup-bar p");
    
    // Ensure the element exists
    if (!successResponse) {
      console.error("Success response element not found.");
      return;
    }
  
    // Create a MutationObserver to monitor text changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" && successResponse.textContent.trim() !== "") {
          // Success message is now visible
          console.log("Subscription successful!");
  
          // Run your custom JavaScript here
          form.remove();
          formText.innerHTML = "Thank you for subscribing";
  
          // Optional: Stop observing after detecting success
          observer.disconnect();
        }
      });
    });
  
    // Observe the success message element for child list changes
    observer.observe(successResponse, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();
})();
